import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Form, message, Modal, Row, Upload } from "antd";
import React from "react";
import { FormBox, InputBox } from "../../../../components/AntdAddons";
import { validations } from "../../../../config/validations/validations";
import SVGIcon from "../../../../utils/SVGIcon";
import { UploadOutlined } from "@ant-design/icons";

const FormComponent: React.FC<any> = (props) => {
  const {
    visible,
    title,
    close,
    form,
    setFileList,
    fileList,
    handleSubmit,
    type,
  } = props;

  const handleChange = () => {
    form.validateFields();
  };
  const resetField = () => {
    setFileList([]);

    if (type === "Edit") {
      const allValues = form.getFieldsValue();
      const fieldsToReset = Object.keys(allValues).filter(
        (field) => field !== "icicid" && field !== "company_name"
      );
      // Reset only the selected fields
      form.resetFields(fieldsToReset);
    } else {
      form.resetFields();
    }
  };
  const handleFileChange = ({ fileList }: any) => {
    setFileList(fileList);
    form.setFieldsValue({ file: fileList.length ? fileList : null });
  };
  const beforeUpload = (file: any) => {
    const isLt10MB = file.size / 1024 / 1024 <= 10;
    if (!isLt10MB) {
      message.error(`${file.name} is larger than 10MB`);
      return Upload.LIST_IGNORE;
    }
    const acceptedFileTypes = [
      "application/pdf",
      "application/msword", // DOC
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX
      "application/vnd.ms-excel", // XLS
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // XLSX
      "text/plain", // TXT
    ];

    if (!acceptedFileTypes.includes(file.type)) {
      message.error(`${file.name} is not a valid file type`);
      return Upload.LIST_IGNORE;
    }
    return isLt10MB;
  };

  return (
    <Modal
      open={visible}
      destroyOnClose
      width={900}
      onCancel={close}
      closeIcon={<FontAwesomeIcon icon={faTimes} />}
      footer={false}
      className="addModal"
      title={title}
    >
      <FormBox
        className="filterForm"
        form={form}
        onFinish={handleSubmit}
        onChange={handleChange}
        validateTrigger={["onBlur"]}
        autoComplete="off"
      >
        <Row gutter={30} align={"top"}>
          <Col xs={24} md={8}>
            <InputBox.Text
              name="company_name"
              disabled={type === "Edit" ? true : false}
              label="Company Name"
              required
              rules={[
                validations.required.text(),
                validations.pattern.whitespace,
                validations.min.text(3),
                validations.max.text(50),
              ]}
            />
          </Col>

          {/* <Col xs={24} md={8}>
            <InputBox.Text
              name="company_id"
              label="Company ID"
              disabled={type === "Edit" ? true : false}
              required
              rules={[
                validations.pattern.numeric,
                validations.pattern.whitespace,
                validations.required.text(),
              ]}
            />
          </Col> */}
          <Col xs={24} md={8}>
            <InputBox.Text
              name="icicid"
              label="ICC ID"
              disabled={type === "Edit" ? true : false}
              required
              maxLength={10}
              rules={[
                validations.required.text(),
                validations.pattern.numeric,
                validations.pattern.whitespace,
              ]}
            />
          </Col>
          <Col xs={24} md={8}>
            <InputBox.Text
              name="price"
              label="Price"
              step="0.00"
              maxLength={10}
              rules={[
                validations.pattern.decimal(2),
                validations.pattern.whitespace,
              ]}
            />
          </Col>
          <Col xs={24} md={8}>
            <InputBox.Text
              name="gb"
              label="GB"
              maxLength={10}
              rules={[
                validations.pattern.numeric,
                validations.pattern.whitespace,
              ]}
            />
          </Col>
          <Col xs={24} md={8}>
            <InputBox.Text
              name="call"
              label="Call"
              maxLength={10}
              rules={[
                validations.pattern.numeric,
                validations.pattern.whitespace,
              ]}
            />
          </Col>
          <Col xs={24} md={8}>
            <InputBox.Text
              name="sms"
              label="SMS"
              maxLength={10}
              rules={[
                validations.pattern.numeric,
                validations.pattern.whitespace,
              ]}
            />
          </Col>
          <Col xs={24} md={8}>
            <InputBox.Text
              name="tell"
              label="Tell"
              placeholder="Tell"
              maxLength={10}
              rules={[
                validations.pattern.numeric,
                validations.pattern.whitespace,
              ]}
            />
          </Col>
          <Col xs={24} md={8}>
            <InputBox.Text
              name="tell2"
              label="Tell2"
              placeholder="Tell2"
              maxLength={10}
              rules={[
                validations.pattern.numeric,
                validations.pattern.whitespace,
              ]}
            />
          </Col>
          <Col xs={24} md={8}>
            <InputBox.Text
              name="fax"
              label="Fax"
              placeholder="Fax"
              maxLength={10}
              rules={[
                validations.pattern.numeric,
                validations.pattern.whitespace,
              ]}
            />
          </Col>
          <Col xs={24} md={8}>
            <InputBox.TextArea
              name="address"
              label="Address"
              placeholder="Address"
              rows={2}
              rules={[
                validations.pattern.whitespace,
                validations.min.text(3),
                validations.max.text(100),
              ]}
            />
          </Col>
          <Col xs={24} md={8}>
            <InputBox.TextArea
              name="description"
              label="Description"
              placeholder="Description"
              rules={[
                validations.pattern.whitespace,
                validations.min.text(3),
                validations.max.text(100),
              ]}
              rows={2}
            />
          </Col>
          <Col xs={24} md={8}>
            <Form.Item name="file" label="Upload File">
              <Upload
                beforeUpload={beforeUpload}
                maxCount={1}
                onChange={handleFileChange}
                defaultFileList={fileList}
                listType="text"
                accept=".pdf,.doc,.docx,.xls,.xlsx,"
              >
                <Button icon={<UploadOutlined />}>Upload File</Button>
              </Upload>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={30} align={"top"}>
          <Col xs={24} md={12} lg={6}>
            <Button type="primary" htmlType="submit">
              {type === "Edit" ? (
                "Submit"
              ) : (
                <>
                  <SVGIcon icon="add" color="#fff" width={55} /> Add
                </>
              )}
            </Button>
          </Col>
          <Col xs={24} md={12} lg={6}>
            <Button type="default" onClick={() => resetField()}>
              Clear
            </Button>
          </Col>
        </Row>
      </FormBox>
    </Modal>
  );
};

export default FormComponent;
